import * as is from 'utilities/is';
import { h, Component } from 'preact';
import { Loader } from 'rendering/components/loader';
import { computeNormalizedRects } from 'utilities/rendering';
import { ANNOTATION_EVENT, APPLICATION_EVENT, PLAYER_EVENT } from 'constants/events';
import { ANNOTATION_TARGETS } from 'constants';
import { PresentationScaleManager } from './components/presentation_scale_manager';
import {
    ExternalTarget,
    PlayerTarget,
    AdjacentTarget
} from './annotations/targets';

export class Targets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: this.props.list,
            updating: true,
            scale: null,
            width: window.innerWidth,
            height: window.innerHeight,
            animate: props.animate,
            dependenciesLoading: false
        };

        this.activeDependencyCount = 0;

        if (props.eventHandlers.includes('onrender')) {
            [PLAYER_EVENT.SIZE_CHANGE, PLAYER_EVENT.LOADEDMETADATA, PLAYER_EVENT.PLAY]
                .forEach(e => {
                    this.props.bus.on(e, this.broadcastRender.bind(this));
                });
        }

        props.bus.on(PLAYER_EVENT.SCALE_CHANGE, this.onPlayerScaleChange.bind(this));
        props.bus.on(APPLICATION_EVENT.ANIMATE_CHANGE, this.onAnimateChange);
        props.bus.on(APPLICATION_EVENT.DEPENDENCIES_LOADING, this.onDependenciesLoadChange);
    }

    onPlayerScaleChange = scale => this.setState({ scale })
    onAnimateChange = animate => this.setState({ animate })

    onDependenciesLoadChange = dependenciesLoading => {
        if (dependenciesLoading) {
            this.activeDependencyCount++;
            this.setState({ dependenciesLoading });
        } else {
            this.activeDependencyCount--;

            if (this.activeDependencyCount === 0) {
                this.setState({ dependenciesLoading });
            }
        }        
    }

    componentDidMount() {
        this.setState({ updating: false });

        this.props.bus.on(ANNOTATION_EVENT.ANNOTATIONS_UPDATED, list => {
            this.setState({ updating: true });
            this.broadcastRender();
        });
    }

    broadcastRender() {
        // wait for next paint before broadcasting
        window.requestAnimationFrame(() => {
            this.setState({ updating: false });
            this.props.bus.emit(APPLICATION_EVENT.RENDER, this.collectRects());
        });
    }

    collectRects() {
        return {
            regionDimensions: this.props.contentDimensions,
            targets: computeNormalizedRects(this.container, '.adjacent-target'),
            annotations: computeNormalizedRects(this.container, '.adjacent-target [class*="popcorn"], .hapyak-annotation-container [class*="popcorn"]')
        };
    }

    render() {
        const 
            { bus, targetList, contentDimensions, scaleToContainer } = this.props,
            { scale, animate, updating } = this.state,
            containerAttrs = {
                'ref': el => this.container = el,
                'className': 'targets',
                'data-animate': String(animate),
                'data-updating': String(updating),
                'data-targets': targetList.join(' '),
                'style': {
                    width: '100%',
                    position: 'relative',
                    paddingTop: `${contentDimensions.container}%`
                }
            };

        return (
            <PresentationScaleManager bus={ bus } aspectRatio={ contentDimensions.container } alwaysScale={ scaleToContainer }>
                <div { ...containerAttrs }>
                    {
                        targetList
                            .map(target => {
                                const settings = {
                                    scale,
                                    target,
                                    key: target,
                                    targetSize: contentDimensions[target],
                                    ...this.props
                                }

                                return (
                                    target === ANNOTATION_TARGETS.PLAYER ?
                                        <PlayerTarget {...settings} /> : (
                                            is.knownTarget(target) ?
                                                <AdjacentTarget {...settings} /> :
                                                <ExternalTarget {...settings} />
                                        )
                                )
                            })
                    }
                    { this.loader }
                </div>
            </PresentationScaleManager>
        );
    }

    get displaySettings() {
        const { display, playerInterface } = this.props;

        if (playerInterface.hasMetadata) {
            return {
                ...display,
                video: {
                    ...display.video,
                    ...playerInterface.dimensions.video
                }
            }
        }

        return display;
    }

    get loader() {
        const styles = {};

        if (this.state.dependenciesLoading) {
            styles.opacity = 1;
            styles.pointerEvents = 'auto';
        }

        return (
            <div className="blocking-loader" style={ styles }>
                <Loader background="rgba(43,51,63,.7)" foreground="rgba(255,255,255,0.85)" size="48"/>
            </div>
        )
    }
}